module.exports = __webpack_public_path__ + "media/images/G-02-0211d57039574877a61be5157d90837f.svg";